import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '网址分类',
    links: [
      { label: '购物电商', to: '/category/shopping' },
      { label: '新闻资讯', to: '/category/news' },
      { label: '视频娱乐', to: '/category/video' },
      { label: '社交平台', to: '/category/social' },
      { label: '学习教育', to: '/category/education' },
    ],
  },
  {
    title: '更多分类',
    links: [
      { label: '金融理财', to: '/category/finance' },
      { label: '科技数码', to: '/category/technology' },
      { label: '旅游出行', to: '/category/travel' },
      { label: '生活服务', to: '/category/life' },
      { label: '政府组织', to: '/category/government' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about#contact' },
      { label: '安全指南', to: '/article/internet-safety-guide' },
      { label: '防骗指南', to: '/article/online-shopping-fraud-prevention' },
      { label: '品牌故事', to: '/article/brand-story' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-compass-3-line text-xl text-primary-500"></i>
              </div>
              <span className="text-base font-heading font-semibold text-foreground-900">
                正品蓝导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专业权威的网址导航平台，汇聚海量正品网站资源，精准分类、安全可信。告别假冒仿冒，一站直达正品官网。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 正品蓝导航 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500">安全上网，从正品蓝导航开始</span>
          </div>
        </div>
      </div>
    </footer>
  );
}